import { ReactNode, useEffect, useState } from "react";
import { AiLLMProps, useAiLLM } from "./useAiLLM";
import { improveGifGenerationPrompt, improveImageGenerationPrompt, improveVideoGenerationPrompt, randomGifPromptGenerator, randomImagePromptGenerator, randomVideoPromptGenerator, spellCorrectionPrompt } from "../utils/aiModels/prompts";
import { aiStateTypes } from "../types/ai/states";

export type GenerationFormatType = 'image' | 'video' | 'gif';

export const usePromptHook = (): [
    generation:any,
    state: aiStateTypes,
    setState: (state:aiStateTypes) => void,
    handleRandomPrompt: (type: 'create' | 'edit', negativePrompt: boolean,format?:GenerationFormatType) => Promise<void>,
    handleCheckPrompt: (promptPositive:string, promptNegative:string, type: 'create' | 'edit',format?:GenerationFormatType) => Promise<void>,
    handleSpellCorrection: (text: string,promptPositive: string, promptNegative:string) => Promise<void>,
    insufficientCreditsDialogLLM: ReactNode
] => {
    const [generation,state,setState,sendMessage,insufficientCreditsDialogLLM] = useAiLLM();
    
    const sendPrompt = async (prompt: string) => {
        setState('send');
        const body: AiLLMProps = {
            model:"gpt-oss:20b",
            messages: [{role: 'user', content: prompt}]
        };

        await sendMessage('chat', body, true);
    };
    const handleRandomPrompt = async (type: 'create' | 'edit', negativePrompt: boolean, format:GenerationFormatType = 'image') => {
        const prompt = format === 'image' 
            ? randomImagePromptGenerator(negativePrompt,type)
            : format === 'video'
                ? randomVideoPromptGenerator(negativePrompt,type)
                : format === 'gif'
                    ? randomGifPromptGenerator(negativePrompt,type)
                    : '';
        await sendPrompt(prompt)     
    };
    const handleCheckPrompt = async (promptPositive:string, promptNegative:string, type: 'create' | 'edit',format:GenerationFormatType = 'image') => {
        const prompt = format === 'image' 
            ? improveImageGenerationPrompt(promptPositive,promptNegative, type)
            : format === 'video'
                ? improveVideoGenerationPrompt(promptPositive,promptNegative, type)
                : format === 'gif'
                    ? improveGifGenerationPrompt(promptPositive,promptNegative, type)
                    : '';
        await sendPrompt(prompt);
    };
    const handleSpellCorrection = async (text: string,promptPositive: string, promptNegative:string) => {
        const prompt = spellCorrectionPrompt(text,promptPositive, promptNegative);
        await sendPrompt(prompt);  
    };

    return [generation, state, setState, handleRandomPrompt, handleCheckPrompt,handleSpellCorrection,insufficientCreditsDialogLLM]
};